/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { NavLink } from "react-router-dom";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import MainHeader from "../../../../Shared/components/Header";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import crudActions from "../../../../CRUD/redux/actions";
import { UnitClassTable } from "./UnitClassTable";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
import { customAlaphabetValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const UnitClass = (props) => {
    const [visible, setVisible] = useState(false);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const { unitClassdetails, loader } = useSelector(state => state.productSetupReducer);
    const [name, setName] = useState('');
    const [addMore, setAddMore] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;

    let menus = [
        {
            "name": "Unit of Measurement",
            "link": `${moduleType === 'Admin' ? '/admin' : '/younote-admin'}/setup/units/unit-measurement`
        }
    ];

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();

    };
    const emptyState = () => {
        setErrorName(false);
    };

    const emptyStateInput = () => {
        setName('');
    };

    const dispatch = useDispatch();

    const onExport = () => {
        loadImportExportData('Unit Class');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.UNITCLASS_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'unitclass',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        // if (roleManagement !== '' && checkViewPermission('Unit Class', history, 'Younote Admin')) {
        loadTasks();
        // }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'unitclass',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleClick = (value) => {
        menus = [
            {
                "name": "Unit of Measurement",
                "link": `${moduleType === 'Admin' ? '/admin' : '/younote-admin'}/setup/units/${value}/unit-measurement`
            }
        ];
        dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, component: "Unit Class" });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
        setTimeout(function () {
            dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, component: "Unit Class" });
        }, 200)
    });

    const createClass = (e) => {
        e.preventDefault()
        let emptyName = customAlaphabetValidation('Unit Class', name);
        emptyState();
        if (emptyName.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'unitclass',
                title: 'Unit Class',
                details: {
                    name: name,
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
        }
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            setErrorName(text);
        }
    }, [createDetails, createError]);

    const handleAddMore = (e) => {
        createClass(e);
        setAddMore(true);
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const [iconAnimation, setIconAnimation] = useState(false);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'}
                links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' }, { 'label': 'Unit Class', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Unit Class'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Unit Class', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space direction="horizontal" align="center" className={clsx(classes.customLink)}>
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Class', 'Action', 'Export') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.margin20r, classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Class', 'Action', 'Import') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.margin20r, classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('Unit Class', 'create', 'Younote Admin')
                                                    || checkCRUDPermission('Unit Class', 'create', 'Admin')) &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.margin20r, classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Unit Class</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Class', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <UnitClassTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                moduleType={moduleType}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                rowClick={(value) => handleClick(value)}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Add Unit Class'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component='form'
                        autoComplete='off'
                        onSubmit={(e) => createClass(e)}
                        id={'unitclass'}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Unit Class Name ", <span key={"Unit Class Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorName ? true : false}
                                helperText={errorName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent, classes.bold)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                    Save & Close
                                </Button><Button
                                    key="add"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                    onClick={(e) => handleAddMore(e)}
                                >
                                    Add More
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'Unit Class'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={unitClassdetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
            <QuickLinks menus={menus} component={"Unit Class"} ></QuickLinks>
        </React.Fragment>
    )
}
export default UnitClass